<template>
  <div class="container">
    <Head v-if="meta.title" v-bind:meta="meta"></Head>
    <Header></Header>
    <Navigation></Navigation>
    <Breadcrumbs
      v-if="breadcrumbs"
      v-bind:breadcrumbs="breadcrumbs"
    ></Breadcrumbs>
    <BiogramsContent
      v-if="columns"
      :columns="columns"
      :total="total"
    ></BiogramsContent>
    <Footer></Footer>
  </div>
</template>

<script>
// libraries
//import Vivus from 'vivus'
import axios from "axios";
import NProgress from "nprogress";

//import Swiper from 'swiper'

import { eventBus } from "@/main.js";

// components
import Head from "@/components/Common/Head.vue";
import Header from "@/components/Header/Header.vue";
import BiogramsContent from "@/components/Biograms/BiogramsContent.vue";
import Navigation from "@/components/Common/Navigation.vue";
import Footer from "@/components/Footer/Footer.vue";
import Breadcrumbs from "@/components/Common/Breadcrumbs.vue";

// https://fizykoteka.ckc.uw.edu.pl/omeka/api/items?item_type=FizykotekaBiogram

// call ajax

// functions

export default {
  name: "Biograms",
  props: ["apiCall"],
  components: {
    Head,
    Header,
    Navigation,
    BiogramsContent,
    Breadcrumbs,
    Footer,
  },
  data() {
    return {
      mySwiper: null,
      breadcrumbs: {
        parent_title: "",
        parent_uri: "",
        self_title: "Biogramy",
        self_uri: window.location.href,
      },
      meta: {
        url: window.location.href,
        description: "Lista biogramów.",
        title: "",
        og_type: "website",
        og_image: "",
      },
      wait: 1,
      letter: null,
      page: 1,
      items: null,
      biograms: null,
      columns: null,
      total: null,
    };
  },
  methods: {
    fetchData() {
      NProgress.start();
      axios
        .get(this.$config.API_PATH + this.apiCall + "&page=" + this.page)
        .then((_resp) => {
          if (!this.items) this.items = [];
          let _this = this;

          _resp.data.forEach((_i) => {
            _this.items.push(_i);
          });

          this.total = Number(_resp.headers["omeka-total-results"]);

          if (this.items.length != this.total) {
            this.page++;
            this.fetchData();
          } else {
            NProgress.done();
            this.parseBiograms();
          }

          this.meta.og_image = require("@/assets/img/default.jpg");
          this.meta.title = "Biogramy";
        });
    },
    parseBiograms() {
      this.biograms = [];
      let _this = this;

      this.items.forEach((_item) => {
        let _m = _item.element_texts;
        let _n = null;
        let _i = null;
        if (_m.find((x) => x.element.id == "52"))
          _n = _m.find((x) => x.element.id == "52").text;

        if (_n) {
          _i = {
            id: _item.id,
            name: _n,
            letter: _n.substring(0, 1).toUpperCase(),
          };

          _this.biograms.push(_i);
        }
      });

      this.columns = [];

      this.biograms.forEach((_b) => {
        if (_this.columns.find((x) => x.letter == _b.letter)) {
          let _index = _this.columns.findIndex((x) => x.letter == _b.letter);
          _this.columns[_index].count++;
          _this.columns[_index].biograms.push(_b);
        } else {
          _this.columns.push({
            letter: _b.letter,
            count: 1,
            height: null,
            biograms: [_b],
          });
        }
      });

      // sorting within columns

      this.columns.forEach((_c) => {
        _c.biograms.sort((a, b) => a.name.localeCompare(b.name));
      });

      // sorting columns

      this.columns.sort((a, b) => a.letter.localeCompare(b.letter));

      //console.log(this.columns);

      this.countHeights();

      this.renderSwiper();
    },
    renderSwiper() {
      let _self = this;
      setTimeout(function () {
        $("h1").addClass("shown"), $(".letter-wrapper").addClass("shown");
        this.mySwiper = new Swiper(".swiper-container", {
          speed: 1,
          autoplay: {
            delay: 0
          },
          slideClass: "letter-wrapper",
          wrapperClass: "biograms-wrapper",
          freeMode: !0,
          centeredSlides: true,
          observer: true,
          slideToClickedSlide: true,
          slidesPerView: "auto",
          watchOverflow: true,
          updateOnWindowResize: true,
          centeredSlidesBounds: true,
          on: {
            init: function (_swiper) {
              if (_self.letter) {
                _self.wait = 0;
                let _letters = _self.$el.querySelectorAll(".letter-wrapper");
                let _element = _self.$el.querySelector(
                  ".letter-wrapper-" + _self.letter.toLowerCase()
                );
                _swiper.updateSize();

                if (_element) {
                  let _id = _element.getAttribute("id");
                  if (this.letter == "Z") {
                    _swiper.slideTo(_letters.length, 500, function () {});
                  } else {
                    _swiper.slideTo(_id, 500, function () {});
                  }
                  _element.className = _element.className + " opened";
                }
              }
            },
            slideChange: function () {
              //swiper.attachEvents()
              $(".biograms-control.go-right").addClass("hidden");
              $(".biograms-control.go-left").addClass("hidden");
            },
            slideChangeTransitionEnd: function (_swiper) {
              _swiper.isBeginning
                ? $(".biograms-control.go-left").addClass("hidden")
                : $(".biograms-control.go-left").removeClass("hidden"),
                _swiper.isEnd
                  ? $(".biograms-control.go-right").addClass("hidden")
                  : $(".biograms-control.go-right").removeClass("hidden");
            },
          },
        });
      }, this.wait),
        setTimeout(function () {
          $(".biograms-control").removeClass("hidden"),
            $(".biograms-control").on("click", function () {
              let ai = mySwiper.activeIndex;
              $(this).hasClass("go-left")
                ? mySwiper.slideTo(ai - 5)
                : mySwiper.slideTo(ai + 5);
            });
        }, 6e3);
      // https://css-tricks.com/snippets/jquery/click-once-and-unbind/
    },
    countHeights() {
      let _heights = [];

      this.columns.forEach((_c) => {
        _heights.push(Number(_c.count));
      });

      let _mh = Math.max.apply(
        Math,
        _heights.map((_m) => _m)
      );

      //console.log([_heights, _mh]);

      let _css_heights = { h1: [], h2: [], h3: [], h4: [], h5: [] };

      for (let _i in _heights) {
        if (_heights[_i] < _mh / 5) {
          _css_heights.h1.push(_heights[_i]);
        } else if (_heights[_i] < (2 * _mh) / 5) {
          _css_heights.h2.push(_heights[_i]);
        } else if (_heights[_i] < (3 * _mh) / 5) {
          _css_heights.h3.push(_heights[_i]);
        } else if (_heights[_i] < (4 * _mh) / 5) {
          _css_heights.h4.push(_heights[_i]);
        } else {
          _css_heights.h5.push(_heights[_i]);
        }
        _i++;
      }

      this.columns.forEach((_c) => {
        let _css_height;
        if (_css_heights.h1.includes(_c.count)) _css_height = 0;
        if (_css_heights.h2.includes(_c.count)) _css_height = 50;
        if (_css_heights.h3.includes(_c.count)) _css_height = 100;
        if (_css_heights.h4.includes(_c.count)) _css_height = 150;
        if (_css_heights.h5.includes(_c.count)) _css_height = 200;

        _c.height = _css_height; // tutaj obliczyc podstawa + dodatek
      });

      //console.log([_heights, _mh, _css_heights, this.columns]);
    },
    renderMe() {
      // preparing heights
      // rewrite pls

      let _heights = [];

      for (const _c in this.columns) {
        _heights.push(this.columns[_c].length);
      }

      // get max value

      let _mh = Math.max.apply(
        Math,
        _heights.map((_m) => _m)
      );

      let _css_heights = { h1: [], h2: [], h3: [], h4: [], h5: [] };

      for (let _i in _heights) {
        if (_heights[_i] < _mh / 5) {
          _css_heights.h1.push(_heights[_i]);
        } else if (_heights[_i] < (2 * _mh) / 5) {
          _css_heights.h2.push(_heights[_i]);
        } else if (_heights[_i] < (3 * _mh) / 5) {
          _css_heights.h3.push(_heights[_i]);
        } else if (_heights[_i] < (4 * _mh) / 5) {
          _css_heights.h4.push(_heights[_i]);
        } else {
          _css_heights.h5.push(_heights[_i]);
        }
        _i++;
      }

      let _scolumns = [];

      for (const column in this.columns) {
        let _css_height = this.columns[column].length;

        /*         if (_css_heights.h1.includes(_css_height)) _css_height = 50;
        if (_css_heights.h2.includes(_css_height)) _css_height = 100;
        if (_css_heights.h3.includes(_css_height)) _css_height = 150;
        if (_css_heights.h4.includes(_css_height)) _css_height = 200;
        if (_css_heights.h5.includes(_css_height)) _css_height = 250; */

        if (_css_heights.h1.includes(_css_height)) _css_height = 0;
        if (_css_heights.h2.includes(_css_height)) _css_height = 50;
        if (_css_heights.h3.includes(_css_height)) _css_height = 100;
        if (_css_heights.h4.includes(_css_height)) _css_height = 150;
        if (_css_heights.h5.includes(_css_height)) _css_height = 200;

        let c = {
          column: column,
          biograms: this.columns[column],
          //'count': Math.pow(2, this.columns[column].length + 1) + 1
          count: _css_height,
        };
        _scolumns.push(c);
      }
      _scolumns.sort(function (a, b) {
        if (a.column < b.column) {
          return -1;
        }
        if (a.column > b.column) {
          return 1;
        }
        return 0;
      });
      this.scolumns = _scolumns;
    },
  },
  mounted() {
    this.letter = this.$router.currentRoute.params.letter;
    this.fetchData();
  },
  watch: {
    $route() {
      this.letter = this.$router.currentRoute.params.letter;
      eventBus.$emit("letterChanged", this.letter);
    },
  },
  head: {
    title: function () {
      return {
        inner: "Biogramy",
      };
    },
    meta: [
      {
        name: "description",
        content: "Lista biogramów.",
      },
    ],
    link: [
      { rel: "stylesheet", href: "//unpkg.com/swiper/swiper-bundle.min.css" },
      {
        rel: "stylesheet",
        href: "//cdn.jsdelivr.net/npm/simplebar@latest/dist/simplebar.css",
      },
    ],
    script: [
      {
        type: "text/javascript",
        src: "//cdn.jsdelivr.net/npm/simplebar@latest/dist/simplebar.min.js",
        async: true,
        body: false,
      },
    ],
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Biograms/Biograms.vue